import React, { useContext, useEffect } from 'react';
import classnames from 'classnames';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useWindowResizeEvent } from '@wix/da-hooks/pkg/useWindowResizeEvent';
import { DeviationViewContext } from '../Context';
import DeviationPageContent from './_partials/DeviationPageContent';
import SiteFooter from '../SiteFooter';
import { DeviationViewMode, SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { useFullscreenEvents } from '../utils/hooks/useFullscreenEvents';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { useDuperbrowseViewType } from '../Duperbrowse/DuperbrowseViewContext';
import { SubscriptionPurchaseFTUEContextProvider } from '../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUEContext';
import { getBiEventComponentByType, getPageTitle, getDeviationAppUrl } from './redux/helpers';
import { getDeviationType, getDeviationResourceType } from '../DeviationViews/_helpers';
import Notifications from '../Notifications';
import { useDeviationChangedCallback } from './hooks/useDeviationChangedCallback';
import DeviationPageHeader from './_partials/DeviationPageHeader';
import DeviationPageLoader from './_partials/DeviationPageLoader';
import { MatureDeviationContextProvider } from '../Context/MatureDeviationContext';
import { getRobotsContent } from '../utils/head';
import s from './DeviationPage.scss';
const DeviationPage = ({ deviation , onLoad , viewMode , onFullscreenEntered , onFullscreenExited , onScreenResize  })=>{
    var _deviation_author;
    const { t  } = useTranslation();
    const { isInDuperbrowse  } = useDuperbrowseViewType();
    const { adsEnabled  } = useContext(SessionContext);
    const hasFullscreen = !adsEnabled;
    useFullscreenEvents({
        enabled: hasFullscreen,
        onFullscreenEntered: ()=>deviation && onFullscreenEntered(deviation),
        onFullscreenExited: ()=>deviation && onFullscreenExited(deviation)
    });
    useWindowResizeEvent(onScreenResize);
    useDeviationChangedCallback(deviation, onLoad);
    useEffect(()=>{
        onScreenResize(window.innerWidth, window.innerHeight);
    }, [
        onScreenResize
    ]);
    const biComponent = getBiEventComponentByType(getDeviationType(deviation));
    const isFullscreen = viewMode === DeviationViewMode.Fullscreen;
    const showHeaderAndFooter = !isFullscreen;
    const appUrl = getDeviationAppUrl(deviation);
    var _deviation_author_useridUuid;
    return /*#__PURE__*/ React.createElement(DeviationViewContext.Provider, {
        value: viewMode
    }, /*#__PURE__*/ React.createElement(Helmet, null, isInDuperbrowse && /*#__PURE__*/ React.createElement("title", null, getPageTitle(deviation, t)), appUrl && /*#__PURE__*/ React.createElement("meta", {
        property: "da:appurl",
        content: `DeviantArt://${appUrl}`
    }), (deviation === null || deviation === void 0 ? void 0 : deviation.isAiUseDisallowed) && /*#__PURE__*/ React.createElement("meta", {
        name: "robots",
        content: getRobotsContent('noimageai')
    })), /*#__PURE__*/ React.createElement("main", {
        role: "main",
        className: classnames(s['root'], isFullscreen && s['fullscreen'])
    }, showHeaderAndFooter && /*#__PURE__*/ React.createElement(DeviationPageHeader, null), !deviation && /*#__PURE__*/ React.createElement(DeviationPageLoader, null), deviation && /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            view: 'submission',
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId,
            page_typeid: getDeviationResourceType(deviation),
            page_itemid: deviation.deviationId,
            creatorid: (_deviation_author_useridUuid = (_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.useridUuid) !== null && _deviation_author_useridUuid !== void 0 ? _deviation_author_useridUuid : '',
            component: biComponent,
            sectionname: 'deviation'
        }
    }, /*#__PURE__*/ React.createElement(MatureDeviationContextProvider, {
        deviation: deviation
    }, /*#__PURE__*/ React.createElement(SubscriptionPurchaseFTUEContextProvider, {
        deviation: deviation
    }, /*#__PURE__*/ React.createElement(DeviationPageContent, {
        deviation: deviation
    })))), showHeaderAndFooter && /*#__PURE__*/ React.createElement(SiteFooter, null)), /*#__PURE__*/ React.createElement(Notifications, {
        wrapperClassName: classnames(viewMode === DeviationViewMode.Normal && s['stage-notifications'])
    }));
};
DeviationPage.displayName = 'DeviationPage';
export default DeviationPage;
